<template minapp="mpx" xlang="wxml">
  <view class="guide">
    <view class="time-container">
      <view wx:for="{{guide.list}}" class="time">{{ item.time }}</view>
    </view>
    <view class="tips-container">
      <view wx:for="{{guide.list}}">
        <view wx:if="{{item.station}}" wx:class="{{ item && item.tips ? 'tips' : 'tips-empty'}}" wx:style="{{item.tips ? {} : index === 0 ? {'margin-right': '26px'} : index === 4 ? {'margin-left': '26px'}:index === 2&&orderDetail ? {'margin-left': '-3px'}:{}}}" wx:style="{{item.tips ? tipsBackground:circleStyle}}">
          {{item.tips}}
        </view>
        <view
          wx:elif="{{index === 1}}"
          class="tips-line"
          wx:class="{{ item.text ? '' : 'tips-line-empty'}}"
          wx:style="{{lineStyle}}"
        >
          <view class="tips-text" wx:if="{{item.text}}" wx:style="{{textStyle}}" style="left:18vw">{{ item.text }}</view>
        </view>
        <view
          wx:elif="{{index === 3}}"
          class="tips-line-second"
          wx:class="{{ item.text ? '' : 'tips-line-empty'}}"
          wx:style="{{lineStyle}}"
        >
          <view class="tips-text" wx:if="{{item.text}}" wx:style="{{textStyle}}" style="right:18vw">{{ item.text }}</view>
        </view>
      </view>
    </view>
    <view class="station-container" wx:style="{{stationFont}}" >
      <view wx:for="{{guide.list}}" wx:class="{{ item.tips ? 'station' : 'station-empty'}}" wx:style="{{stationStyle}}"  wx:style="{{index == 0?'text-align:left':index==2?'text-align:center':index==4?'text-align:right':''}}">{{
        item.station
      }}</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      guide: {
        type: Object,
        value: {}
      },
      orderDetail: {
        type: Boolean,
        value: false
      },
      isMakeOrder: {
        type: Boolean,
        value: false
      }
    },
    data: {},
    computed: {
      lineStyle() {
        const style = {}
        style['--line-color'] = this.orderDetail ? '#ADD2FF' : '#C2DEFF'
        style['--line-empty'] = this.orderDetail ? '#FFFFFF' : '#338FFF'
        return style
      },
      stationStyle() {
        const style = {}
        style['--station-color'] = this.orderDetail ? '#FFFFFF' : '#222222'
        style['--station-empty'] = this.orderDetail ? 'rgba(255, 255, 255, 0.6)' : '#666666'
        return style
      },
      textStyle(){
        const style = {}
        style['--text-color'] = this.guide.type ==3? '#FFFFFF' : '#338FFF'
        style['--text-background'] = this.guide.type ==3 ? '#338FFF' : '#C2DEFF'
        style['--text-border'] = (this.guide.type ==3&&this.orderDetail) ? '1.5px solid #FFFFFF' : 'none'
        return style
      },
      circleStyle(){
        const style = {}
        style['--circle-border'] = this.orderDetail? '#FFFFFF' : '#338FFF'
        style['--circle-background'] = this.orderDetail ? '#338FFF' : '#FFFFFF'
        return style
      },
      stationFont(){
        const style = {}
        style['--station-size'] = this.isMakeOrder ? '12px' : '14px'
        return style
      },
      tipsBackground(){
        const style = {}
        style['--tips-background'] = this.isMakeOrder ? '#F2F6F9' : '#FFFFFF'
        style['--tips-border'] = this.orderDetail ? 'none':'1.25px solid #338FFF'
        return style
      }
    },
    methods: {}
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .time-container
    display flex
    justify-content space-between
    font-size 32px
    color #222222
    font-family Barlow Semi Condensed
    font-weight 400
    .time
      min-width 20%
  .tips-container
    font-size 10px
    font-weight 600
    display flex
    align-items center
    justify-content space-between
    color #338FFF
    position relative
    margin-top 2px
    margin-bottom 4px
    .tips
      border var(--tips-border)
      border-radius 137.5px
      z-index 2
      background var(--tips-background)
      position relative
      width 36px
      height 19px
      font-size 10px
      text-align center
      line-height 19px
      font-weight 600
    .tips-empty
      border 3px solid var(--circle-border)
      border-radius 50%
      padding 4px
      z-index 2
      background  var(--circle-background)
      position relative
    .tips-line
      position absolute
      background var(--line-color)
      background-position center
      height 5px
      width 50%
      top 8px
      left 8px
      z-index 1
    .tips-line-second
      position absolute
      background var(--line-color)
      background-position center
      height 5px
      width 50%
      top 8px
      right 8px
      z-index 1
    .tips-line-empty
      background var(--line-empty)
    .tips-text
      position absolute
      top -8px
      background var(--text-background)
      border-radius 103px
      color var(--text-color)
      width 52px
      height 19px
      font-size 10px
      text-align center
      line-height 19px
      border var(--text-border)
  .station-container
    display flex
    font-size var(--station-size)
    justify-content space-between
    font-weight 400
    .station
      flex 1
      color var(--station-color)
    .station-empty
      flex 1
      color var(--station-empty)
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>